import urlApi from './urlApi';
export var UPLOAD_FILE_REQUEST = 'UPLOAD_FILE_REQUEST';
export var UPLOAD_FILE_SUCCESS = 'UPLOAD_FILE_SUCCESS';
export var UPLOAD_FILE_ERROR = 'UPLOAD_FILE_ERROR';
export function uploadFile(file) {
    return function (dispatch) {
        dispatch({
            type: UPLOAD_FILE_REQUEST,
            payload: true,
        });
        urlApi().postFile(file).then(function (res) {
            dispatch({
                type: UPLOAD_FILE_SUCCESS,
                payload: res,
            });
        })
            .catch(function (err) {
            dispatch({
                type: UPLOAD_FILE_ERROR,
                payload: err
            });
        });
    };
}
//# sourceMappingURL=uploadFile.js.mapimport urlApi from './urlApi';
export var UPLOAD_FILE_REQUEST = 'UPLOAD_FILE_REQUEST';
export var UPLOAD_FILE_SUCCESS = 'UPLOAD_FILE_SUCCESS';
export var UPLOAD_FILE_ERROR = 'UPLOAD_FILE_ERROR';
export function uploadFile(file) {
    return function (dispatch) {
        dispatch({
            type: UPLOAD_FILE_REQUEST,
            payload: true,
        });
        urlApi().postFile(file).then(function (res) {
            dispatch({
                type: UPLOAD_FILE_SUCCESS,
                payload: res,
            });
        })
            .catch(function (err) {
            dispatch({
                type: UPLOAD_FILE_ERROR,
                payload: err
            });
        });
    };
}
//# sourceMappingURL=uploadFile.js.map